import {Howl, Howler} from 'howler';
import Swiper from "swiper/bundle";

export default (targetId, audiolist) => {

    /*!
    *  Howler.js Audio Player Demo
    *  howlerjs.com
    *
    *  (c) 2013-2020, James Simpson of GoldFire Studios
    *  goldfirestudios.com
    *
    *  MIT License
    */
    const target = document.getElementById(targetId);
    const v_window = {};
    // Cache references to DOM elements.
    var elms = ['track', 'timer', 'duration', 'playBtn', 'pauseBtn', 'prevBtn', 'nextBtn', 'progress', 'bar', 'waveform', 'loading', 'playlist', 'list', 'volume', 'volumeBtn', 'barEmpty', 'barFull', 'sliderBtn'];
    elms.forEach(function(elm) {
      v_window[elm] = target.querySelector('.' + elm);
    });

    /**
     * Player class containing the state of our playlist and where we are in it.
     * Includes all methods for playing, skipping, updating the display, etc.
     * @param {Array} playlist Array of objects with playlist song details ({title, file, howl}).
     */
    var Player = function(playlist) {
      this.playlist = playlist;
      this.index = 0;
      this.playstate = false;

      // Display the title of the first track.
      v_window.track.innerHTML = playlist[0].title;

      // Setup the playlist display.
      playlist.forEach(function(song, index) {
        var div = document.createElement('div');
        div.className = 'list-song swiper-slide';
        div.innerHTML = (index + 1) + '. ' + song.title;
        div.onclick = function() {
          player.skipTo(playlist.indexOf(song));
        };
        v_window.list.appendChild(div);
      });

      var slider = new Swiper(target.querySelector('.playlist'), {
          mousewheel: true,
          slidesPerView: 3,
          scrollbar: {
              el: target.querySelector('.swiper-scrollbar'),
              draggable: true,
            },
            direction: 'vertical',
      });
      this.slider = slider;
    };
    Player.prototype = {
      /**
       * Play a song in the playlist.
       * @param  {Number} index Index of the song in the playlist (leave empty to play the first or current).
       */
      play: function(index) {
        var self = this;
        var sound;

        index = typeof index === 'number' ? index : self.index;
        var data = self.playlist[index];

        // If we already loaded this track, use the current one.
        // Otherwise, setup and load a new Howl.
        if (data.howl) {
          sound = data.howl;
        } else {
          sound = data.howl = new Howl({
            src: data.file,
            html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
            onplay: function() {
              // Display the duration.
              v_window.duration.innerHTML = self.formatTime(Math.round(sound.duration()));

              // Start updating the progress of the track.
              requestAnimationFrame(self.step.bind(self));

              // Start the wave animation if we have already loaded
              v_window.pauseBtn.style.display = 'block';
              self.playstate = true;
            },
            onload: function() {
              // Start the wave animation.
              v_window.loading.style.display = 'none';
            },
            onend: function() {
              // Stop the wave animation.
              self.skip('next');
            },
            onpause: function() {
              // Stop the wave animation.
              self.playstate = false;
            },
            onstop: function() {
              // Stop the wave animation.
            },
            onseek: function() {
              // Start updating the progress of the track.
              requestAnimationFrame(self.step.bind(self));
            }
          });
        }

        // Begin playing the sound.
        sound.play();

        // Update the track display.
        v_window.track.innerHTML = data.title;

        // Show the pause button.
        if (sound.state() === 'loaded' || 'loading') {
          v_window.playBtn.style.display = 'none';
          v_window.pauseBtn.style.display = 'block';
          v_window.waveform.style.pointerEvents = 'auto';
        } else {
          v_window.loading.style.display = 'block';
          v_window.playBtn.style.display = 'none';
          v_window.pauseBtn.style.display = 'none';
          v_window.waveform.style.pointerEvents = 'none';
        }

        // Keep track of the index we are currently playing.
        self.index = index;

        for (let index = 0; index < v_window.list.children.length; index++) {
            const item = v_window.list.children[index];
            item.classList.remove('nowplaying');
        }
        v_window.list.children[index].classList.add('nowplaying');

        this.slider.slideTo(index);
      },
      unload: function(index) {
        var self = this;

        index = typeof index === 'number' ? index : self.index;
        var playlist = self.playlist;
        playlist.forEach(item => {
          if(item.howl){
            item.howl.stop();
            item.howl.unload();
          }
        });
        v_window.playBtn.removeAttribute('style')
        v_window.pauseBtn.removeAttribute('style')
        v_window.waveform.style.pointerEvents = 'none';
        v_window.list.innerHTML = '';
        v_window.track.innerHTML = '';
        v_window.progress.style.width = '0%';
      },

      /**
       * Pause the currently playing track.
       */
      pause: function() {
        var self = this;

        // Get the Howl we want to manipulate.
        var sound = self.playlist[self.index].howl;

        // Puase the sound.
        sound.pause();

        // Show the play button.
        v_window.playBtn.style.display = 'block';
        v_window.pauseBtn.style.display = 'none';
      },

      /**
       * Skip to the next or previous track.
       * @param  {String} direction 'next' or 'prev'.
       */
      skip: function(direction) {
        var self = this;

        // Get the next track based on the direction of the track.
        var index = 0;
        if (direction === 'prev') {
          index = self.index - 1;
          if (index < 0) {
            index = self.playlist.length - 1;
          }
        } else {
          index = self.index + 1;
          if (index >= self.playlist.length) {
            index = 0;
          }
        }

        self.skipTo(index);
      },

      /**
       * Skip to a specific track based on its playlist index.
       * @param  {Number} index Index in the playlist.
       */
      skipTo: function(index) {
        var self = this;

        // Stop the current track.
        if (self.playlist[self.index].howl) {
          self.playlist[self.index].howl.stop();
        }

        // Reset progress.
        v_window.progress.style.width = '0%';

        // Play the new track.
        self.play(index);
      },

      /**
       * Set the volume and update the volume slider display.
       * @param  {Number} val Volume between 0 and 1.
       */
       volume: function(val) {
        var self = this;

        // Update the global volume (affecting all Howls).
        Howler.volume(val);

        // Update the display on the slider.
        var barWidth = val;
        v_window.barFull.style.width = (barWidth * 100) + '%';
        v_window.sliderBtn.style.left = (barWidth * 100) + '%';
      },

      /**
       * Seek to a new position in the currently playing track.
       * @param  {Number} per Percentage through the song to skip.
       */
      seek: function(per) {
        var self = this;

        // Get the Howl we want to manipulate.
        var sound = self.playlist[self.index].howl;

        // Convert the percent into a seek position.
        sound.seek(sound.duration() * per);
      },

      /**
       * The step called within requestAnimationFrame to update the playback position.
       */
      step: function() {
        var self = this;

        // Get the Howl we want to manipulate.
        var sound = self.playlist[self.index].howl;

        // Determine our current seek position.
        var seek = sound.seek() || 0;
        v_window.timer.innerHTML = self.formatTime(Math.round(seek));
        v_window.progress.style.width = (((seek / sound.duration()) * 100) || 0) + '%';

        // If the sound is still playing, continue stepping.
        if (sound.playing()) {
          requestAnimationFrame(self.step.bind(self));
        }

      },

      /**
       * Format the time from seconds to M:SS.
       * @param  {Number} secs Seconds to format.
       * @return {String}      Formatted time.
       */
      formatTime: function(secs) {
        var minutes = Math.floor(secs / 60) || 0;
        var seconds = (secs - minutes * 60) || 0;

        return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      }
    };

    // Setup our new audio player class and pass it the playlist.
    var player = new Player(audiolist);

    // Bind our player controls.
    v_window.playBtn.addEventListener('click', function() {
      player.play();
    });
    v_window.pauseBtn.addEventListener('click', function() {
      player.pause();
    });
    v_window.prevBtn.addEventListener('click', function() {
      player.skip('prev');
    });
    v_window.nextBtn.addEventListener('click', function() {
      player.skip('next');
    });
    v_window.waveform.addEventListener('click', function(event) {
      player.seek((event.clientX - v_window.waveform.getBoundingClientRect().left) / v_window.waveform.clientWidth);
    });

    // Setup the event listeners to enable dragging of volume slider.
    var currentVolumePer = 1;
    v_window.barEmpty.addEventListener('click', function(event) {
        var per = event.layerX / parseFloat(v_window.barEmpty.scrollWidth);
        currentVolumePer = per;
        player.volume(per);
    });
    v_window.sliderBtn.addEventListener('mousedown', function() {
      window.sliderDown = true;
    });
    v_window.sliderBtn.addEventListener('touchstart', function() {
      window.sliderDown = true;
    });
    v_window.volume.addEventListener('mouseup', function() {
      window.sliderDown = false;
    });
    v_window.volume.addEventListener('mouseleave', function() {
      window.sliderDown = false;
    });
    v_window.volume.addEventListener('touchend', function() {
      window.sliderDown = false;
    });
    v_window.volumeBtn.addEventListener('click', function() {
      if(this.classList.contains('zero')){
        this.classList.remove('zero');
        player.volume(currentVolumePer);
      }else{
        this.classList.add('zero');
        player.volume(0);
      }
    });

    var move = function(event) {
        if (window.sliderDown) {
          var x = (event.clientX - v_window.barEmpty.getBoundingClientRect().left) || (event.touches[0].clientX - v_window.barEmpty.getBoundingClientRect().left);
          var layerX = x;
          var per = Math.min(1, Math.max(0, layerX / parseFloat(v_window.barEmpty.scrollWidth)));
          player.volume(per);
        }
      };

    v_window.volume.addEventListener('mousemove', move);
    v_window.volume.addEventListener('touchmove', move);

    window[targetId] = player;

}
